import React from "react";
import { Loading } from "../view/common/Loading";
import { Paths } from "../../Paths";
import { Navigate } from "react-router-dom";
import { RegistrationStatus, useRegistrationStatus } from "../provider/RegistrationStatusProvider";

export function RootRouter() {
    const registered = useRegistrationStatus();

    const routing = () => {
        switch (registered) {
            // User情報がある場合
            case RegistrationStatus.REGISTERED:
                return <Navigate to={Paths.role} replace/>;
            // User情報がない場合
            case RegistrationStatus.UNREGISTERED:
                return <Navigate to={Paths.notRegistration} replace/>;
            // User情報が取得中の場合、取得するまで留める
            default:
                return <Loading/>;
        }
    };

    return routing();
}
